import React, { useState, useEffect } from 'react';
import { Box, MenuItem, TextField, Typography } from '@mui/material';
import { searchSummary } from '../common/form/MobileFilterCollapse';
import SearchCard, { fieldProps } from '../common/list/SearchCard';
import 'dayjs/locale/ko';
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

// 판매관리비 관리(/sales-cost-manage) 검색 영역 - chancemng 설계(fc30533) 적용(2026-10-22).
// 추가/업로드/다운 버튼은 breadcrumb action으로 옮겼다(SalesCostListContainer).
export const SalesCostListBox = ({ formik, onReset, companyOptions }) => {
  const [searchStrtDt, setSearchStrtDt] = useState(null);
  const [searchEndDt, setSearchEndDt] = useState(null);

  useEffect(() => {
    if (formik.values.searchStrtDt) {
      setSearchStrtDt(dayjs(formik.values.searchStrtDt));
    }
    if (formik.values.searchEndDt) {
      setSearchEndDt(dayjs(formik.values.searchEndDt));
    }
  }, [formik.values.searchStrtDt, formik.values.searchEndDt]);

  const onChangeDate = (newValue, name) => {
    formik.setFieldValue(name, newValue);
  };

  return (
    <SearchCard
      summary={searchSummary(formik.values)}
      onSubmit={formik.handleSubmit}
      onReset={onReset}
      submitting={formik.isSubmitting}
      gridSx={{
        gridTemplateAreas: {
          xs: `"company" "keyword" "search" "period" "btns"`,
          sm: `"company keyword" "search period" "btns btns"`,
        },
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'minmax(140px, 0.7fr) minmax(160px, 0.8fr)',
        },
        '@media (min-width:1440px)': {
          gridTemplateAreas: `"company keyword search period btns"`,
          gridTemplateColumns:
            'minmax(120px, 0.5fr) minmax(150px, 0.6fr) minmax(160px, 1fr) minmax(280px, 1.1fr) 190px',
        },
      }}
    >
      {/* 회사 */}
      <Box sx={{ gridArea: 'company', minWidth: 0 }}>
        <TextField
          {...fieldProps}
          select
          fullWidth
          required={false}
          id="companyCd"
          name="companyCd"
          label="회사"
          value={formik.values?.companyCd || 'ALL'}
          onChange={formik.handleChange}
          error={formik.touched.companyCd && Boolean(formik.errors.companyCd)}
          helperText={formik.touched.companyCd && formik.errors.companyCd}
        >
          <MenuItem value="ALL">전체</MenuItem>
          {companyOptions.map((option) => (
            <MenuItem key={option.companyCd} value={option.companyCd}>
              {option.companyNm}
            </MenuItem>
          ))}
        </TextField>
      </Box>

      {/* 검색키워드 */}
      <Box sx={{ gridArea: 'keyword', minWidth: 0 }}>
        <TextField
          {...fieldProps}
          select
          fullWidth
          required={false}
          id="searchKeyword"
          name="searchKeyword"
          label="검색키워드"
          value={formik.values.searchKeyword}
          onChange={formik.handleChange}
          error={formik.touched.searchKeyword && Boolean(formik.errors.searchKeyword)}
          helperText={formik.touched.searchKeyword && formik.errors.searchKeyword}
        >
          <MenuItem value="scLarge">계정과목(대)</MenuItem>
          <MenuItem value="scSmall">계정과목(소)</MenuItem>
          <MenuItem value="scWh">사용처</MenuItem>
          <MenuItem value="companyNm">회사명</MenuItem>
          <MenuItem value="crtNm">등록자</MenuItem>
        </TextField>
      </Box>

      {/* 검색어 */}
      <Box sx={{ gridArea: 'search', minWidth: 0 }}>
        <TextField
          {...fieldProps}
          fullWidth
          required={false}
          id="searchWords"
          name="searchWords"
          label="검색어"
          value={formik.values.searchWords || ''}
          onChange={formik.handleChange}
          error={formik.touched.searchWords && Boolean(formik.errors.searchWords)}
          helperText={formik.touched.searchWords && formik.errors.searchWords}
        />
      </Box>

      {/* 검색 시작~종료일 */}
      <Box sx={{ gridArea: 'period', minWidth: 0 }}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minWidth: 0 }}>
            <DatePicker
              label="검색 시작일"
              format="YYYY-MM-DD"
              mask={'____-__-__'}
              id="searchStrtDt"
              name="searchStrtDt"
              value={searchStrtDt}
              onChange={(newValue) => {
                setSearchStrtDt(dayjs(newValue));
                onChangeDate(dayjs(newValue), 'searchStrtDt');
              }}
              slotProps={{
                textField: {
                  ...fieldProps,
                  sx: { minWidth: 0, flex: '1 1 130px' },
                  error: formik.touched.searchStrtDt && Boolean(formik.errors.searchStrtDt),
                  helperText: formik.touched.searchStrtDt && formik.errors.searchStrtDt,
                },
              }}
            />
            <Typography variant="body2" color="text.secondary" sx={{ flexShrink: 0 }}>
              ~
            </Typography>
            <DatePicker
              label="검색 종료일"
              format="YYYY-MM-DD"
              mask={'____-__-__'}
              id="searchEndDt"
              name="searchEndDt"
              value={searchEndDt}
              onChange={(newValue) => {
                setSearchEndDt(dayjs(newValue));
                onChangeDate(dayjs(newValue), 'searchEndDt');
              }}
              slotProps={{
                textField: {
                  ...fieldProps,
                  sx: { minWidth: 0, flex: '1 1 130px' },
                  error: formik.touched.searchEndDt && Boolean(formik.errors.searchEndDt),
                  helperText: formik.touched.searchEndDt && formik.errors.searchEndDt,
                },
              }}
            />
          </Box>
        </LocalizationProvider>
      </Box>
    </SearchCard>
  );
};
